/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { isSpaceTypeWithUniqueActivity } from "../helpers";

const useAvailableActivitiesBySpaceType = ({
	form, universityActivityList
}) => {
	const { spaceTypeId, availableActivityIds } = form.value;
	const [universityActivityListBySpaceType, setUniversityActivityListBySpaceType] = useState([]);
	useEffect(() => {
		if (universityActivityList.length === 0) return;
		const newUniversityActivityListBySpaceType = filterUniversityActivities();
		setUniversityActivityListBySpaceType(
			newUniversityActivityListBySpaceType
		);
	}, [universityActivityList, spaceTypeId]);
	useEffect(() => {
		if (!spaceTypeAndAvailableActivitiesHasContent() || universityActivityListBySpaceType.length === 0) return;
		checkConsistenceOfAvailableActivitiesSelectedBySpaceType();
	}, [universityActivityListBySpaceType]);
	function checkConsistenceOfAvailableActivitiesSelectedBySpaceType() {
		const newAvailableActivityIds = availableActivityIds
			.filter(activityId => universityActivityListBySpaceType.some(
				universityActivity => universityActivity.id === activityId
			));
		truncateAvailableActivitiesIfItsNeeded(newAvailableActivityIds);
		form.setAvailableActivities(newAvailableActivityIds);
	}
	function truncateAvailableActivitiesIfItsNeeded(newAvailableActivityIds) {
		/**
		Nota: Según requerimiento, se considera ciertos tipos de espacios son de actividad única.
		*/
		if (isSpaceTypeWithUniqueActivity(spaceTypeId))
			newAvailableActivityIds.length = 1;
	}
	function spaceTypeAndAvailableActivitiesHasContent() {
		return spaceTypeId && availableActivityIds.length > 0;
	}
	function filterUniversityActivities() {
		switch (spaceTypeId) {
			default:
				return [...universityActivityList];
		}
	}
	return universityActivityListBySpaceType;
}

export default useAvailableActivitiesBySpaceType;